<div
    class="header-area bg-white box-shadow transition"
    [ngClass]="{'active': isToggled}"
>
    <div class="d-md-flex align-items-center justify-content-between">
        <div class="header-left-side d-flex align-items-center">
            <div
                class="burger-menu position-relative transition lh-1"
                [ngClass]="{'active': isToggled}"
                (click)="toggle()"
            >
                <i-feather name="align-left"></i-feather>
            </div>
        </div>
        <ul class="header-right-side d-flex align-items-center m-0 p-0 list-unstyled">

            <li>
                <div class="date-btn position-relative">
                    <i-feather name="calendar"></i-feather> {{ formattedDate }}
                </div>
            </li>

            <li>
                <button mat-button [matMenuTriggerFor]="profileMenu" class="profile-menu-btn">
                    <div class="avatar-initials">
                        {{ getUserInitials() }}
                    </div>
                </button>
                <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
                    <div class="menu-header d-flex align-items-center">
                        <div class="avatar-initials-large">
                            {{ getUserInitials() }}
                        </div>
                        <div class="title">
                            <a [routerLink]="homeRoute" class="d-inline-block fw-medium">
                                {{ getUserFullName() }}
                            </a>
                            <span class="designation d-block text-body">
                                {{ getRoleDisplayName(currentUser?.roles?.[0]) || 'Usuario' }}
                            </span>
                        </div>
                    </div>
                    <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">
                        <li class="position-relative transition fw-medium">
                            <i class="material-symbols-outlined">
                                logout
                            </i>
                            Salir
                            <a routerLink="/authentication/logout" class="link-btn d-block position-absolute left-0 right-0 top-0 bottom-0 z-1"></a>
                        </li>
                    </ul>
                </mat-menu>
            </li>
        </ul>
    </div>
</div>